import axios from 'axios'
import store from '../../store'

import { Message } from 'element-ui'
import * as Strings from '../../assets/strings'

// import { Message } from 'element-ui'

export default function setup () {
  axios.interceptors.request.use(function (config) {
    // console.log('TCL: setup -> store.auth.state', store.state)
    const token = store.state.auth['access_token']
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })

  axios.interceptors.response.use((response) => { // intercept the global error
    return response
  }, function (error) {
    console.log('response ERROR', error)
    if (error.response) {
      if (error.response.status === 404) {
        Message.error(Strings.messages.errors.notFound)
      }
    } else if (error.request) {
      Message.error(Strings.messages.errors.noInternet)
    } else {
      Message.error(Strings.messages.errors.common)
    }
    return Promise.reject(error)
  })
}
